import { Address } from 'viem'
import { EMPTY_ADDRESS } from '@/shared/constants/address.ts'

export function isNativeToken(tokenAddress: Address) {
  return tokenAddress === EMPTY_ADDRESS
}
